import { GAME_TYPE } from "constants/game.constants";
import FavoriteResourceCalculator from "../abstraction";

const resourceKey = "favorite-games-";
class FavoriteGamesCalculator extends FavoriteResourceCalculator {
	static _instance = null;

	static get instance() {
		return FavoriteGamesCalculator._instance
	}

	updateByBets(bets) {
		if (this.disabled) {
			return;
		}
		bets.forEach(bet => {
			this.increment(bet.gameType)
		})
	}

	constructor(keyPostfix) {
		super(resourceKey + keyPostfix);
		FavoriteGamesCalculator._instance = this;
	}
}

export default FavoriteGamesCalculator;